var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading65_container"},[_c('div',{staticClass:"div"},[_c('p',{attrs:{"id":"h2"}},[_vm._v("Loading...."),_c('span',{attrs:{"id":"lol"}})])])])
}]

export { render, staticRenderFns }